var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sec-textlist-base"},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item.name)),(_vm.items.length === index + 1 && _vm.itemsReceive.length > _vm.limitLen)?_c('span',[_vm._v("他...")]):_vm._e()])}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06bdf9d7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/SecTextList.vue
// module id = null
// module chunks = 